export const profiloAriannaSelector = (state) => state.screening.profiloArianna;

export const screeningResultSelector = (state) => state.screening.screeningResult;

export const adhesionStatusSelector = (state) => state.screening.adhesionStatus;

export const inviteReminderSelector = (state) => state.screening.inviteReminder;

export const appointmentConfirmSelector = (state) => state.screening.appointmentConfirm;







